import { render } from "./NewsAdd.vue?vue&type=template&id=f7cfdd90"
import script from "./NewsAdd.vue?vue&type=script&lang=js"
export * from "./NewsAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__